import React, { Component } from 'react';
import { Markup } from 'interweave';
import ReactPlayer from 'react-player';
import { QuestionTypes } from '../../../constants/QuestionTypes';
import MCViewer from './QA_Viewer/multipleChoice_viewer';
import MatrixViewer from './QA_Viewer/matrix_viewer';
import DropdownViewer from './QA_Viewer/dropdown_viewer';
import PicklistViewer from './QA_Viewer/picklist_viewer';
import CheckboxViewer from './QA_Viewer/checkbox_viewer';
import { isNullOrEmpty } from '../../common/commonFuncs';
import * as Icon from 'react-feather';
import InstitutionViewer from "./QA_Viewer/institution_viewer";
import { TextArea } from 'semantic-ui-react';
import moment from 'moment';
import CustomTooltip from '../../common/CustomTooltip';
import { getFormWidgetResponse } from '../../../services/formService';

class QAViewer extends Component {
	state = {
		Widget_ID: this.props.Widget_ID ? this.props.Widget_ID : 0,
		Widget_Type: 0,
		Question_ID: this.props.Question_ID ? this.props.Question_ID : null,
		Question_Type_ID: 0,
		Question_Text: '',
		Description: '',
		Indicate_Response: false,
		Response_Required: false,
		Align_Horizontal: false,
		Allow_Multiple_Selection: false,
		Response: { Answer_ID: null, Answer_Text: '' },
		Matrix_Questions: [],
		Matrix_Answers: [],
		error_status: false,
		SurveyMode: this.props.SurveyMode ? true : false,
		PrimaryKey: this.props.PrimaryKey ? this.props.PrimaryKey : '',
		Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
		Form_ID: this.props.Form_ID ? this.props.Form_ID : 0,
		Form_BehaviorOnLoad: this.props.Form_BehaviorOnLoad ? this.props.Form_BehaviorOnLoad : null,
		selectedInst: this.props.selectedInst,
		preloadQAData: null,
		loading: true,
		Form_SecondaryIDName : this.props.Form_SecondaryIDName ? this.props.Form_SecondaryIDName : null,
		Form_SecondaryIDValue : this.props.Form_SecondaryIDValue ? this.props.Form_SecondaryIDValue : null,
		widgetsQA: this.props.widgetsQA ? this.props.widgetsQA : [],
		preloadFormData: this.props.preloadFormData ? this.props.preloadFormData : [],
		isValidAnswer: true,
		ShowSelectAll: [], // List of Answer_Text values used to indicate which column should show select all option
		Allow_Leading_Zero: false,
    	Prepopulate_Today_Date: false,
		Hide: this.props.Hide ? this.props.Hide : false,
		isRow: this.props.isRow,
		Prepopulate_Response_Form_ID: 0,
		Prepopulate_Response_Widget_ID: 0
	};

	async componentDidMount() {
		//Get config -> get data -> display form
		this.getConfig()
		await this.getPreloadData()
		this.setState({ loading: false });
	}

	async componentDidUpdate(prevProps, prevState) {
		if (this.props.refreshWidget) {
			let Response = this.state.Response
			Response.Answer_Text = Object.values(this.props.Responses).find(w  => w.Widget_ID === this.props.Widget_ID).Responses[0].Answer_Text
			this.setState({Response})
			this.props.handleRefreshWidget()
		}
	}

	getConfig() {
		let Widget_ID = this.props.Widget_ID,
			widgetsQA = this.state.widgetsQA,
			data = {},
			wQAs = [],
			tempWQA = [];

		widgetsQA && (tempWQA = (widgetsQA.filter((w) => w.Widget_ID == parseInt(Widget_ID))));
		if (tempWQA.length > 0) {
			let tempObj = {
				'Question_Config': [
					{
						'Question_ID': tempWQA[0].Question_ID,
						'Question_Type_ID': tempWQA[0].Question_Type_ID,
						'Question_Text': tempWQA[0].Question_Text,
						'Description': tempWQA[0].Description,
						'Indicate_Response': tempWQA[0].Indicate_Response,
						'Align_Horizontal': tempWQA[0].Align_Horizontal,
						'Allow_Multiple_Selection': widgetsQA.some((w)=>w.Allow_Multiple_Selection === true && w.Widget_ID===parseInt(Widget_ID)),
						'Linked_Question_ID': tempWQA[0].Linked_Question_ID,
						'Response_Required': tempWQA[0].Response_Required,
						'Custom_Render': tempWQA[0].Custom_Render,
						'Valid_Condition': tempWQA[0].Valid_Condition,
						'ShowSelectAll': tempWQA[0].ShowSelectAll,
						'Allow_Leading_Zero': tempWQA[0].Allow_Leading_Zero,
            			'Prepopulate_Today_Date': tempWQA[0].Prepopulate_Today_Date,
						'Hide': tempWQA[0].Hide,
						'Prepopulate_Response_Form_ID': tempWQA[0].Prepopulate_Response_Form_ID,
						'Prepopulate_Response_Widget_ID': tempWQA[0].Prepopulate_Response_Widget_ID
					}],
				'QuestionAnswers_Config': []
			}
			widgetsQA.forEach(
				function (widget) {
					if (widget.Widget_ID == parseInt(Widget_ID) && ((widgetsQA.filter((w) => w.Widget_ID == Widget_ID)).length > 0)) {
						tempObj['QuestionAnswers_Config'].push({
							'Answer_ID': widget.Answer_ID,
							'Answer_Number': widget.Answer_Number,
							'Answer_Text': widget.Answer_Text
						})
					}
				}
			)
			wQAs.push(tempObj)
		}

		//console.log('widgetsQA', widgetsQA);
		let matrixQA = tempWQA.filter((el)=>el.Linked_Question_ID!==null), Matrix_Questions=[...this.state.Matrix_Questions], Matrix_Answers=[...this.state.Matrix_Answers];
		matrixQA.forEach(
			function (widget) {
				Matrix_Questions = [
					...Matrix_Questions,
					{
						Question_ID: widget.Question_ID,
						Question_Text: widget.Question_Text,
						Question_Type_ID: widget.Question_Type_ID,
						Description: widget.Description,
						Deleted: widget.Deleted
					}
				];
				Matrix_Answers=[
					...Matrix_Answers,{
						'Question_ID': widget.Question_ID,
						'Answer_ID': widget.Answer_ID,
						'Answer_Number': widget.Answer_Number,
						'Answer_Text': widget.Answer_Text
					}
				]
			})
		this.setState({ Matrix_Questions, Matrix_Answers });

		data = wQAs[0]['Question_Config'];

		let Indicate_Response = false, Response_Required = false;
		if (data[0]) {
			let Response_Required = data[0].Response_Required === null ? false : data[0].Response_Required;
			this.setState({ Question_ID: tempWQA[0].Question_ID });
			this.setState({ Response_Required });
			if (data[0].Linked_Question_ID == null) {
				this.setState({ Question_ID: data[0].Question_ID });
				this.setState({ Question_Type_ID: data[0].Question_Type_ID });
				const Question_Text = data[0].Question_Text.replace('</p><p>', '<br />').replace(/(<p[^>]+?>|<p>|<\/p>)/gim, '');
				this.setState({ Question_Text });
				this.setState({ Description: data[0].Description });
				Indicate_Response = data[0].Indicate_Response;
				this.setState({ Indicate_Response });
				this.setState({ Align_Horizontal: data[0].Align_Horizontal });
				this.setState({
					Allow_Multiple_Selection: data[0].Allow_Multiple_Selection ? true : false,
				});
				this.setState({Custom_Render: data[0].Custom_Render});
				this.setState({Valid_Condition: data[0].Valid_Condition});
				if(data[0].ShowSelectAll && data[0].ShowSelectAll !== '') {
					this.setState({ShowSelectAll: data[0].ShowSelectAll.split(',')});
				}
				this.setState({Allow_Leading_Zero: data[0].Allow_Leading_Zero ? true : false})
        		this.setState({Prepopulate_Today_Date: data[0].Prepopulate_Today_Date ? true : false})
				this.setState({ Hide: data[0].Hide ? true : false })
				this.setState({Prepopulate_Response_Form_ID: data[0].Prepopulate_Response_Form_ID ? data[0].Prepopulate_Response_Form_ID : 0})
				this.setState({Prepopulate_Response_Widget_ID: data[0].Prepopulate_Response_Widget_ID ? data[0].Prepopulate_Response_Widget_ID : 0})
			}
		}

		// Load question answers
		let Question_Answers = wQAs.length > 0 ? wQAs[0]['QuestionAnswers_Config'] : [];
		this.setState({ Question_Answers });
		if (Response_Required) {
			this.props.OnUpdate(this.props.Question_Number, {
				Responses: [],
				Response_Required: (this.state.Question_Type_ID === QuestionTypes.Checkbox) ? false : Response_Required,
			});
		}
		return Question_Answers ? 'success' : 'failed';

	}

	async prepopulateResponse(Prepopulate_Response_Form_ID, Prepopulate_Response_Widget_ID, Question_ID) {
		if (Prepopulate_Response_Form_ID > 0 && Prepopulate_Response_Widget_ID > 0){
			const { data } = await getFormWidgetResponse(this.state.PrimaryKey, Prepopulate_Response_Form_ID, Prepopulate_Response_Widget_ID, Question_ID)
			return data[0]
		}
	}

	async getPreloadData() {
		//Get recent saved data for a form with pk
		let Question_ID = this.state.Question_ID;
		if (this.state.Form_BehaviorOnLoad != 1 || (this.state.Form_BehaviorOnLoad === 1 && this.props.Form_BehaviorOnSave !== 2)) {
			let preloadQAData = this.state.preloadFormData.find(ques => parseInt(ques.Question_ID) === parseInt(Question_ID)), Response = {}
			let Answer_Text = ''
			let tempWQA = []
			this.state.widgetsQA && (tempWQA = (this.state.widgetsQA.filter((w) => w.Widget_ID === parseInt(this.state.Widget_ID))));
			if (this.state.preloadFormData.length === 0 && tempWQA[0].Prepopulate_Today_Date) {
				var today = new Date()
				var dd = String(today.getDate()).padStart(2, '0')
				var mm = String(today.getMonth() + 1).padStart(2, '0')
				var yyyy = today.getFullYear()
				today = yyyy + '-' + mm + '-' + dd
				Answer_Text = today
			}
			if (this.state.preloadFormData.length === 0 && tempWQA[0].Prepopulate_Response_Form_ID && tempWQA[0].Prepopulate_Response_Widget_ID) {
				let prepopulateResponse = await this.prepopulateResponse(tempWQA[0].Prepopulate_Response_Form_ID, tempWQA[0].Prepopulate_Response_Widget_ID, Question_ID)
				preloadQAData = {
					Question_ID: Question_ID,
					Answer_ID: prepopulateResponse.Answer_ID,
					Answer_Text: prepopulateResponse.Answer_Text
				}
			}
			Response.Question_ID = preloadQAData ? preloadQAData.Question_ID : null;
			Response.Answer_Text = preloadQAData ? preloadQAData.Answer_Text : Answer_Text ? Answer_Text : null;
			Response.Answer_ID = preloadQAData ? preloadQAData.Answer_ID : null;
			this.setState({ Response, preloadQAData })
			this.handleSimpleInput(Response.Answer_Text, this.state.Question_Type_ID)
		}
		else {
			if (this.props.Form_BehaviorOnSave == 2) {
				Response.Question_ID = null;
				Response.Answer_Text = null
				Response.Answer_ID = null
				this.setState({ preloadQAData: null });
			}
		}
	}

	handleSimpleInput(value, type) {
		if (type === QuestionTypes.Date && value) {
			value = moment(value).format('YYYY-MM-DD')
		}
		const {Question_Answers, Response_Required, SurveyMode } = this.state;
		if (SurveyMode) {
			if ((type === QuestionTypes.Numeric || type === QuestionTypes.Numeric_Tally) && value) {
				const string_value = value
        const [minObj,maxObj]=Question_Answers;
        const minimumValue = parseInt(minObj.Answer_Text);
        const maximumValue = parseInt(maxObj.Answer_Text);
				value = QuestionTypes.Numeric ? parseFloat(value) : parseInt(value);
				if (isNaN(value) || value < minimumValue || value > maximumValue || string_value.length > maximumValue.toString().length) {
					this.setState({ error_status: true });
					return;
				}
				if (this.state.Allow_Leading_Zero) {
					value = string_value
				}
			}

			/* Check Date Validation */
			let isValidAnswer = true;
			if (this.state.Question_Type_ID === QuestionTypes.Date && this.state.Valid_Condition !== null) {
				let Valid_Condition = JSON.parse(this.state.Valid_Condition),
					inputValue = moment(value).format('YYYY/MM/DD'),
					currentDate = moment(new Date()).format('YYYY/MM/DD');

				if (Valid_Condition['Date_From'] !== null && Valid_Condition['Date_From'] !== '-1') {
					Valid_Condition['Date_FromDate'] = (Valid_Condition['Date_From'] === 'current') ? currentDate :
						moment(Valid_Condition['Date_FromDate']).format('YYYY/MM/DD');
				}
				if (Valid_Condition['Date_To'] !== null && Valid_Condition['Date_To'] !== '-1') {
					Valid_Condition['Date_ToDate'] = (Valid_Condition['Date_To'] === 'current') ? currentDate :
						moment(Valid_Condition['Date_ToDate']).format('YYYY/MM/DD');
				}

				// any date is valid if date validation has not been configured
				if (Valid_Condition.length === 0 || (
					(Valid_Condition['Date_From'] === null || Valid_Condition['Date_From'] === '-1') &&
					(Valid_Condition['Date_To'] === null || Valid_Condition['Date_To'] === '-1')
				)) {
					isValidAnswer = true;
				}
				else if ((Valid_Condition['Date_FromDate'] != null && inputValue < Valid_Condition['Date_FromDate']
					&& inputValue !== Valid_Condition['Date_Placeholder']) || (Valid_Condition['Date_ToDate'] != null
					&& inputValue > Valid_Condition['Date_ToDate'] && inputValue !== Valid_Condition['Date_Placeholder']))  {
					isValidAnswer = false;
				}
				else if (Valid_Condition['Date_MinAge'] !== null && Valid_Condition['Date_MinAge'] !== '' &&
						((moment.duration(moment(currentDate).diff(moment(inputValue))).asYears()) < parseInt(Valid_Condition['Date_MinAge']))){ isValidAnswer = false; }
				else if (Valid_Condition['Date_MaxAge'] !== null && Valid_Condition['Date_MaxAge'] !== '' &&
						((moment.duration(moment(currentDate).diff(moment(inputValue))).asYears()) > parseInt(Valid_Condition['Date_MaxAge']))){ isValidAnswer = false; }
				this.setState({ isValidAnswer });
				//console.log('After \n', inputValue, Valid_Condition, isValidAnswer);
				let elWidget = document.getElementById('W' + this.state.Widget_ID);
				elWidget.classList.remove('is-invalid');
				!isValidAnswer && elWidget.classList.add('is-invalid');
			}

			let Response = { ...this.state.Response };
			Response.Answer_Text = value;
			this.setState({ error_status: false, Response });
			this.props.OnUpdate(this.props.Question_Number, {
				Responses: Response_Required && isNullOrEmpty(value) ? [] : [{ Question_Number:this.props.Question_Number, Question_ID: this.state.Question_ID, ...Response}],
				Response_Required: Response_Required,
				Question_Number:this.props.Question_Number,
				isValidAnswer: isValidAnswer
			});
		}
	}

	render() {
		const {
			loading,
			Question_Type_ID,
			Question_Text,
			Question_Answers,
			Question_ID,
			Matrix_Questions,
			Matrix_Answers,
			Widget_ID,
			Description,
			Indicate_Response,
			Align_Horizontal,
			Response_Required,
			Allow_Multiple_Selection,
			error_status,
			Response,
			isValidAnswer,
			Hide
		} = this.state;

		if (loading) return <h2>Loading...</h2>;

		return (
			<div className='card-body' hidden={Hide || this.props.Hide}>
				<div className={Align_Horizontal ? 'd-flex justify-content-start' : ''}>
					<div className={Align_Horizontal ? 'col-sm-5' : 'col-sm-12'}>
						<h5 className='card-title'>
							<Markup tagName='div' className="d-inline" content={(Response_Required ? '*' : '') + 'Q' + (typeof this.props.Question_Number !== 'string' ? (this.props.Question_Number + 1) : this.props.Question_Number) + '. ' + Question_Text} />
							{Description && (
								<CustomTooltip title={Description} placement='top' className="text-muted pl-1 d-inline">
									<Icon.Info size={20}/>
								</CustomTooltip>
							)}

							{Indicate_Response && (
								<CustomTooltip title='Responded' placement='top' className="pl-1 d-inline">
									<Icon.CheckCircle size={18} color='#00ac69' />
								</CustomTooltip>
							)}
						</h5>
					</div>

					<div className='col'>
						{
							// text questions
							Question_Type_ID === QuestionTypes.Text && (
                                <input
                                    key={'W' + Widget_ID}
                                    type='text'
                                    className='form-control'
                                    disabled={this.props.disabled}
                                    value={Response.Answer_Text}
                                    onChange={(e) => this.handleSimpleInput(e.target.value, Question_Type_ID)}/>
							)
						}
						{
							// textarea question
							Question_Type_ID === QuestionTypes.Textarea && (
                                <TextArea maxLength={5000} key={'W' + Widget_ID} className='form-control'
                                          disabled={this.props.disabled}
                                          value={Response.Answer_Text}
                                          onChange={(e) => this.handleSimpleInput(e.target.value, Question_Type_ID)}/>
                            )
						}
						{
							// identifier question
							Question_Type_ID === QuestionTypes.Identifier && (
                                <input
                                    key={'W' + Widget_ID}
                                    type='text' className='form-control' value={Response.Answer_Text}
                                    onChange={(e) => this.handleSimpleInput(e.target.value, Question_Type_ID)}/>
                            )
						}

						{
							// numeric/tally questions
							(Question_Type_ID === QuestionTypes.Numeric || Question_Type_ID === QuestionTypes.Numeric_Tally) && (
								<div className='form-row'>
									<div className='col-sm-6'>
										<input
											key={'W' + Widget_ID} disabled={this.props.disabled}
											type={Question_Type_ID === QuestionTypes.Numeric_Tally ? 'number' : 'text'}
											className={'form-control' + (error_status ? ' is-invalid' : '')}
											value={Response.Answer_Text}
											// onChange={(e) =>
											// 	this.handleSimpleInput(
											// 		e.target.value >= Question_Answers[0].Answer_Text &&
                      //     e.target.value <= Question_Answers[1].Answer_Text
                      //     ? e.target.value : Response.Answer_Text,
											// 		Question_Type_ID
											// 	)
											// }
                      onChange={(e) =>
												this.handleSimpleInput(
                          e.target.value,
													Question_Type_ID
												)
											}
											min={Question_Answers[0].Answer_Text}
											max={Question_Answers[1].Answer_Text}
										/>
										<div className='invalid-feedback' key={'INVALIDQ' + Widget_ID}>
											Not a valid numeric entry
										</div>
									</div>
								</div>
							)
						}

						{
							// video questions
							Question_Type_ID === QuestionTypes.Video && <ReactPlayer key={'W' + Widget_ID} url={Question_Answers[0].Answer_Text} controls={true} />
						}

						{
							// date questions
							Question_Type_ID === QuestionTypes.Date && (
								<div className='form-group row' key={'W' + Widget_ID}>
									<div className={this.state.isRow ? 'col-sm-12' : 'col-sm-6'}>
                                        <input key={'date' + Widget_ID} id={'W' + Widget_ID} type='date'
                                               disabled={this.props.disabled}
                                               className='form-control' value={Response.Answer_Text}
                                               onChange={(e) => this.handleSimpleInput(e.target.value, Question_Type_ID)}
											   onPaste={(e => this.handleSimpleInput(e.clipboardData.getData('text'), Question_Type_ID))}/>
									</div>
								</div>
							)
						}

						{
							// time questions
							Question_Type_ID === QuestionTypes.Time && (
								<div className='form-group row' key={'W' + Widget_ID}>
									<div className={this.state.isRow ? 'col-sm-12' : 'col-sm-6'}>
										<input
											key={'time' + Widget_ID}
											type='time'
											className='form-control'
                                            disabled={this.props.disabled}
											value={Response.Answer_Text}
											//step='1'
											onChange={(e) => this.handleSimpleInput(e.target.value, Question_Type_ID)}
										/>
									</div>
								</div>
							)
						}

						{
							// Multiple Choice
							Question_Type_ID === QuestionTypes.Multiple_Choice && (
								<MCViewer
									key={'W' + Widget_ID}
									OnUpdate={this.props.OnUpdate}
									Question_ID={Question_ID}
									Question_Number={this.props.Question_Number}
									Question_Answers={Question_Answers}
									Response_Required={Response_Required}
									PrimaryKey={this.state.PrimaryKey}
									Project_ID={this.state.Project_ID}
									Answer_ID={Response.Answer_ID}
									isMultiple={Allow_Multiple_Selection}
									SurveyMode={this.state.SurveyMode}
									preloadQAData={this.state.preloadQAData}
                                    disabled={this.props.disabled}
								/>
							)
						}

						{
							// Scale questions
							Question_Type_ID === QuestionTypes.Scale && (
								<MCViewer
									key={'W' + Widget_ID}
									OnUpdate={this.props.OnUpdate}
									Question_ID={Question_ID}
									Question_Number={this.props.Question_Number}
									Question_Answers={Question_Answers}
									isScale={true}
									Response_Required={Response_Required}
									PrimaryKey={this.state.PrimaryKey}
									Project_ID={this.state.Project_ID}
									Answer_ID={Response.Answer_ID}
									SurveyMode={this.state.SurveyMode}
									preloadQAData={this.state.preloadQAData}
                                    disabled={this.props.disabled}
								/>
							)
						}

						{
							// Matrix questions
							Question_Type_ID === QuestionTypes.Matrix && (
								<MatrixViewer
									key={'W' + Widget_ID}
									Question_ID={Question_ID}
									OnUpdate={this.props.OnUpdate}
									Question_Answers={Question_Answers}
									Matrix_Questions={Matrix_Questions}
									Matrix_Answers={Matrix_Answers}
									isMultiple={Allow_Multiple_Selection}
									Question_Number={this.props.Question_Number}
									Response_Required={Response_Required}
									PrimaryKey={this.state.PrimaryKey}
									Project_ID={this.state.Project_ID}
									ShowSelectAll={this.state.ShowSelectAll}
                                    disabled={this.props.disabled}
								/>
							)
						}

						{
							// Dropdown questions
							Question_Type_ID === QuestionTypes.Dropdown && (
								<DropdownViewer
									key={'W' + Widget_ID}
									Question_ID={Question_ID}
									OnUpdate={this.props.OnUpdate}
									Question_Number={this.props.Question_Number}
									Response_Required={Response_Required}
									PrimaryKey={this.state.PrimaryKey}
									Project_ID={this.state.Project_ID}
									Answer_ID={Response.Answer_ID}
									isMultiple={Allow_Multiple_Selection}
									preloadQAData={this.state.preloadQAData}
                                    disabled={this.props.disabled}
								/>
							)
						}

						{
							// Dropdown question for Institution
							Question_Type_ID === QuestionTypes.Institution && (
								<InstitutionViewer
									key={'W' + Widget_ID}
									Question_ID={Question_ID}
									OnUpdate={this.props.OnUpdate}
									Question_Number={this.props.Question_Number}
									Response_Required={Response_Required}
									PrimaryKey={this.state.PrimaryKey}
									Project_ID={this.state.Project_ID}
									Answer_ID={this.state.selectedInst}
									isMultiple={Allow_Multiple_Selection}
									selectedInst= {this.state.selectedInst}
                                    disabled={this.props.disabled}
								/>
							)
						}

						{Question_Type_ID === QuestionTypes.Picklist && (
							<PicklistViewer
								key={'W' + Widget_ID}
								PrimaryKey={this.state.PrimaryKey}
								Question_ID={Question_ID}
								OnUpdate={this.props.OnUpdate}
								Question_Answers={Question_Answers}
								Question_Number={this.props.Question_Number}
								Response_Required={Response_Required}
								Project_ID={this.state.Project_ID}
								Answer_ID={Response.Answer_ID}
								preloadQAData={this.state.preloadQAData}
								selectedInst= {this.state.selectedInst}
								Custom_Render={this.state.Custom_Render}
                                disabled={this.props.disabled}
							/>
						)}

						{Question_Type_ID === QuestionTypes.Checkbox && (
							<CheckboxViewer
								key={'W' + Widget_ID}
								Question_ID={Question_ID}
								Question_Number={this.props.Question_Number}
								Response_Required={Response_Required}
								SurveyMode={this.state.SurveyMode}
								Widget_ID={this.props.Widget_ID}
								OnUpdate={this.props.OnUpdate}
								preloadQAData={this.state.preloadQAData}
                                disabled={this.props.disabled}
							/>
						)}
					</div>
					{!isValidAnswer && (
						<div className='mt-n1 ml-4 text-danger'>
							<label for={'W' + Widget_ID} className=''>Please record a valid response.</label>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default QAViewer;
